/* ============================================================
   GOB Club toggle (T5) — PDP buy box
   Drives the existing gob-membership.js state machine.
   Does NOT modify gob-membership.js. Delete this file to roll back.
   ============================================================ */
(function () {
  'use strict';

  function clean(html) {
    return String(html)
      .replace(/<sup>0+<\/sup>/, '')
      .replace(/[.,]00([^0-9]|$)/, '$1');
  }

  function money(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney && theme.settings) {
      var out = theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      if (theme.settings.superScriptPrice && out.indexOf('<sup>') === -1) {
        var sep = (out.indexOf(',') !== -1 && theme.settings.moneyFormat &&
                   theme.settings.moneyFormat.indexOf('amount_with_comma') !== -1) ? ',' : '.';
        if (out.indexOf(sep) !== -1) out = out.replace(sep, '<sup>') + '</sup>';
      }
      return out;
    }
    return (cents / 100).toFixed(2);
  }

  function init(widget) {
    if (widget.dataset.gobToggleInit === '1') return;

    var toggle = widget.querySelector('[data-club-toggle]');
    var panel  = widget.querySelector('[data-club-panel]');
    var title  = widget.querySelector('[data-toggle-title]');
    var optStd = widget.querySelector('[data-option="standard"]');
    var optMem = widget.querySelector('[data-option="member"]');
    if (!toggle || !optStd || !optMem) return;

    widget.dataset.gobToggleInit = '1';

    var scope = widget.closest('[data-section-id]') ||
                widget.closest('.product-single') ||
                document;

    function variantPrice() {
      var json = scope.querySelector('script[data-product-json]');
      var sel  = scope.querySelector('[data-product-select]');
      if (json && sel) {
        try {
          var data = JSON.parse(json.textContent);
          var id = parseInt(sel.value, 10);
          for (var i = 0; i < data.variants.length; i++) {
            if (data.variants[i].id === id) return data.variants[i].price;
          }
          if (typeof data.price === 'number') return data.price;
        } catch (e) {}
      }
      var raw = optMem.getAttribute('data-member-price');
      if (raw) return Math.round(parseFloat(raw.replace(',', '.')) * 100 / 0.7);
      return null;
    }

    function refresh() {
      var price = variantPrice();
      if (!price) return;

      var kit  = Math.round(price * 0.7);
      var club = (window.GOBMembership && GOBMembership.price) || 0;
      var save = Math.floor((price - kit) / 100) * 100;

      var elItem  = widget.querySelector('[data-panel-item]');
      var elClub  = widget.querySelector('[data-panel-club]');
      var elTotal = widget.querySelector('[data-panel-total]');
      /* The kit line shows the saving being made: the normal price struck
         through, then the club price. This rewrites the whole cell, so both
         halves have to be built here — the markup in the snippet only survives
         until the first refresh(). Keep the two in step. */
      if (elItem)  elItem.innerHTML  =
        '<s class="gob-club-panel__was">' + money(price) + '</s>' +
        '<span class="gob-club-panel__now">' + money(kit) + '</span>';
      if (elClub)  elClub.innerHTML  = money(club);
      if (elTotal) elTotal.innerHTML = money(kit + club);

      if (title && !toggle.classList.contains('is-on')) {
        title.innerHTML = 'Save ' + clean(money(save)) + ' with GOB Club';
      }
    }

    function setState(on, fire) {
      toggle.classList.toggle('is-on', on);
      toggle.setAttribute('aria-checked', on ? 'true' : 'false');
      if (panel) panel.hidden = !on;

      // keep the existing widget's state in sync
      optStd.classList.toggle('is-selected', !on);
      optMem.classList.toggle('is-selected', on);

      if (fire) {
        try { (on ? optMem : optStd).click(); } catch (e) {}
      }

      if (title) {
        title.innerHTML = on
          ? (toggle.getAttribute('data-label-on') || 'GOB Club pricing on')
          : (toggle.getAttribute('data-label-off') || 'Save with GOB Club');
      }
      refresh();
    }

    toggle.addEventListener('click', function () {
      setState(!toggle.classList.contains('is-on'), true);
    });

    toggle.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter' || e.key === 'Spacebar') {
        e.preventDefault();
        toggle.click();
      }
    });

    var sel = scope.querySelector('[data-product-select]');
    if (sel) sel.addEventListener('change', function () { setTimeout(refresh, 80); });
    document.addEventListener('variant:change', function () { setTimeout(refresh, 80); });

    // initial paint — no click, so nothing races with gob-membership.js
    setState(false, false);
    setTimeout(refresh, 250);
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-membership-pricing]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();